import Divider from '../Divider/Divider';
/** @component */

export default Divider;